import { Icon } from '../../../../utilities/icomoon-css';
import { PayRentTypes } from '../../PayRentTypes';
import React from 'react';
import { Button } from '@codeparva/ui-components-library';
import { failureScreenLabels } from '../../constants/accountPanelConfigs';
import { SectionCardTitle, Text } from '../../../../components/textVariations';

export const FailureScreen = ({
  errorDetails,
  clickHandler,
}: PayRentTypes.TFailureScreen) => {
  const { duplicatePaymentMessage, buttonLabel } = failureScreenLabels;
  const displayMessage = () => {
    switch (errorDetails) {
      case 'Transaction is duplicate':
        return duplicatePaymentMessage;
      default:
        return errorDetails;
    }
  };
  return (
    <div className="failurePaymentContainer" data-testid="payment-failure-card">
      <div className="smallScreenHeading is-hidden-tablet">
        <p>Pay Rent</p>
      </div>
      <div className="failureIconContainer" data-testid="payment-failure-icon">
        <Icon name="tfw-danger-circle-cp" size={42}></Icon>
      </div>
      <div className="failedHeading">
        <SectionCardTitle>Payment Failed</SectionCardTitle>
      </div>
      <p className="failureDetails" data-testid="payment-failure-message">
        {displayMessage()}
      </p>
      <Button
        className="paymentFailureGoBackButton"
        onClick={clickHandler}
        data-testid="pay-again-btn"
      >
        <Icon name="tfw-arrow-left-cp" size={24} color="white"></Icon>
        <Text className="pl-3">{buttonLabel}</Text>
      </Button>
    </div>
  );
};
